import React, { Component } from "react";
import helpers from "../helpers";
import firebase from "../redux/store";

import Login from "./pages/login";
import Main from "./pages/main";
import Printer from "./pages/printer";
import Wallet from "./pages/wallet";
// import Account from "./pages/account";

import "../styles/framework.css";
import "../index.css";
import "../styles/style.css";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

require("../scripts/custom.js");

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      page: "main",
      printer: null,
      user: null,
      userRef: null,
      client: null,
    };
  }

  change(page) {
    if (page == "main") {
      history.pushState({}, null, "/");
    }
    this.setState({
      loading: false,
      page,
    });
  }

  printer(qrcode) {
    return new Promise(async (resolve, reject) => {
      try {
        let printerRef = await helpers.getPrinterByQRCode(qrcode);
        if (printerRef) {
          let printer = await helpers.getPrinter(printerRef);
          printer.model = printer.model
            .replace(new RegExp(printer.manufacturer, "i"), "")
            .trim();
          this.setState({ printer, printerRef, page: "printer" });
          resolve();
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  async fetchUrlParameters() {
    return new Promise(async (resolve, reject) => {
      if (location.search.length > 0) {
        let printer = helpers.getUrlParameter("printer");

        // QR code is deprecated make sure Ono and Ramat Gan doesn't have them.
        const qrcode = helpers.getUrlParameter("qrcode");
        if (qrcode) printer = qrcode;

        if (printer) {
          try {
            await this.printer(printer);
          } catch (e) {}
        }
      }
      resolve();
    });
  }

  componentDidMount() {
    // @firebase/firestore: Firestore (6.6.2): Could not reach Cloud Firestore backend. Backend didn't respond within 10 seconds.
    // This typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.
    // remove the session! needs to be fixed.

    // ONLINE_STATE_TIMEOUT_MS make it bigger than 10
    // firebaseLocalStorage fbase_key restore or prevent delete

    $("body").on("click", "*[data-menu]", helpers.activateMenu);
    $("body").on("click", ".menu-hider, .close-menu", helpers.closeMenu);

    firebase.auth().onAuthStateChanged(async (user) => {
      let subscribe = null;
      if (user) {
        let userRef = firebase.firestore().collection("clients").doc(user.uid);
        this.setState({ userRef });
        await this.fetchUrlParameters();
        subscribe = this.state.userRef.onSnapshot((snapshot) => {
          let client = null;
          if (snapshot.exists) {
            client = snapshot.data();
            this.setState({ user });
            console.log(this.state.user.uid);
          } else {
            subscribe();
            firebase.auth().signOut();
          }
          this.setState({ client, loading: false });
        });
      } else {
        this.setState({ user, loading: false });
        if (subscribe) {
          subscribe();
          console.log("logged out");
        }
      }
    });
  }

  render() {
    let page;
    if (this.state.loading) {
      page = <div className="preload-spinner border-highlight"></div>;
    } else {
      if (!this.state.user) {
        page = <Login app={this} />;
      } else {
        page = <Main app={this} />;
        if (this.state.printer && this.state.page == "printer") {
          page = (
            <Printer
              className="page page-printer"
              app={this}
              user={this.state.user}
              client={this.state.client}
              printer={this.state.printer}
              printerRef={this.state.printerRef}
            />
          );
        } else {
          switch (this.state.page) {
            case "wallet":
              page = <Wallet className="page" app={this} />;
              break;
            // case "account":
            //   page = <Account className="page" app={this} />;
            //   break;
          }
        }
      }
    }

    return (
      <div id="app">
        <div
          className="snackbars text-center"
          style={{ top: 0, bottom: "auto" }}
        >
          <a href="#" id="app-error"></a>
        </div>
        {/* <div id="app-install" style={{textTransform: 'uppercase', position: 'absolute', top: 50+'px', left: 0, background: '#0080a2', color: 'white', zIndex: 100, width: 100+'%', textAlign: 'center', padding: 10+'px', display: 'none'}}>install</div> */}
        {page}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app.js